import { NodeSpec } from 'prosemirror-model';

import { BaseExtension } from '@lyearn/lygo-core';

import { NODE_NAME } from './consts';
import plugins from './plugins';

export default class CheckList extends BaseExtension {
  get schema(): NodeSpec {
    return {
      content: 'check_list_item+',
      group: 'block',
      parseDOM: [],
      toDOM: () => ['ul', { class: 'check-list' }, 0],
    };
  }

  get name(): string {
    return NODE_NAME;
  }

  plugins = plugins;
}
